export function extractSessionsFromPayload<T = Record<string, unknown>>(
  payload: unknown,
): T[] {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (!payload || typeof payload !== "object") {
    return [];
  }

  const record = payload as Record<string, unknown>;

  if (Array.isArray(record.sessions)) {
    return record.sessions as T[];
  }

  if ("data" in record) {
    return extractSessionsFromPayload<T>(record.data);
  }

  return [];
}